import { routeHead } from "@/lib/routeHead";
import { META_DESCRIPTIONS } from "@/lib/metaDescriptions";
import { createFileRoute } from "@tanstack/react-router";
import MarketingSalesHub from "@/pages/MarketingSalesHub";

export const Route = createFileRoute("/by/marketing-sales")({
  head: () => routeHead('Маркетынг і продажы — Прадукты AGAPE', META_DESCRIPTIONS.marketing.by, '/by/marketing-sales'),
  component: MarketingSalesHub,
});
